export default "__VITE_ASSET__DNMEWocc__";